import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  chains: {
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: 'repeat(4, 2fr)',
      gap: 8,
    },
  },
  chain: {
    background: theme.secondary.s1,
    padding: 8,
    height: 40,
    borderRadius: theme.borderRadius.md,
    transition: 'all 0.25s ease-in-out',
    opacity: '0.48',
    width: '100%',

    img: {
      width: 24,
      height: 24,
      borderRadius: theme.borderRadius.md,
    },

    '&:hover': {
      background: theme.secondary.s6,
      opacity: '1',
    },

    '&:disabled': {
      pointerEvents: 'none',
    },
  },
  selectedChain: {
    background: theme.secondary.s1,
    opacity: 'initial',
  },
  wrap: {
    position: 'relative',
    width: '100%',
  },
  tag: {
    ...dFlex(),
    background: theme.accent.a1,
    borderRadius: theme.borderRadius.xxl,
    padding: '0px 4px',
    position: 'absolute',
    zIndex: 1000,
    top: '0',
    transform: 'translate(0, -50%)',
    right: '10px',
  },
}));

export default useStyles;
